import ProfileItemForm from "./ProfileItemForm";
import SearchBrandsInput from "../../../components/form/SearchBrandsInput";
import React, {useMemo, useState} from "react";
import {Button, Divider, Empty, Select, Tag} from "antd";
import FlipMove from "react-flip-move";
import LoadingSpinner from "../../../components/LoadingSpinner";
import {PictureOutlined} from "@ant-design/icons";
import InfoTooltip from "../../../components/InfoTooltip";
import {useAPI} from "../../../config/API";
import ProfileKeyClientRow from "../../profiles/components/ProfileKeyClientRow";
import {FormInputComponent} from "../../../components/form/Form";

const MAX_TAGS_COUNT = 12
const MAX_BRANDS_COUNT = 4
const MAX_LINKS_COUNT = 3
const MAX_IMAGE_ASSETS_COUNT = 10
const MAX_DOC_ASSETS_COUNT = 10
const tagRender = (props) => {
    let {label, value, closable, onClose, type, className} = props || {};
    const colorMap = {
        industries: 'default',
        skills: 'geekblue',
        disciplines: 'purple'
    };

    const onPreventMouseDown = (event) => {
        event.preventDefault();
        event.stopPropagation();
    };

    return (
        <Tag
            color={colorMap[type] || 'default'}
            onMouseDown={onPreventMouseDown}
            closable={closable}
            onClose={onClose}
            className={className}>
            {label}
        </Tag>
    );
};

const isValidURLFormat = (string) => {
    const urlPattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?$/;
    return urlPattern.test(string);
}
export default class KeyClientsForm extends ProfileItemForm {

    static ItemType = 'Work Sample'

    static FormClass = 'talent-role-form add-talent-form add-client-form '

    static ShowProfilePreview = true;

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            useCustomClientInput: !this.state.model?.brand && this.state.model?.id,
            searchInput: ''
        }
    }

    getModelFromProps() {

        let {
            industries = [], skills = [], disciplines = [], assets, docAssets = [], imgAssets, ...model
        } = {...(this.props.model || {})}

        imgAssets = TB.map(imgAssets || [], asset => {
            if (asset.id) {
                return {
                    ...asset,
                    thumbUrl: asset.path,
                    url: asset.path,
                }
            }
            return asset
        })
        industries = TB.map(industries, item => ({...item, type: 'industries', value: `industry-${parseInt(item.id)}`}))
        skills = TB.map(skills, item => ({...item, type: 'skills', value: `skill-${parseInt(item.id)}`}))
        disciplines = TB.map(disciplines, item => ({
            ...item,
            type: 'disciplines',
            value: `discipline-${parseInt(item.id)}`
        }))


        return {...(this.props.model || {}), imgAssets, industries, skills, disciplines}
    }

    onChange(props) {

        let changedModel = TB.cloneDeep(this.state.model);
        for (let [key, value] of Object.entries(props)) {
            changedModel = TB.set(changedModel, key, value);
        }

        if (!this.state.model?.brand && props.brand) {
            changedModel.headline = props.brand.name;
            changedModel.logo_path = props.brand.icon;
        }

        if (changedModel.imgAssets?.length || changedModel.docAssets?.length) {
            changedModel.assets = TB.concat(TB.cloneDeep(changedModel.imgAssets), TB.cloneDeep(changedModel.docAssets));
        } else changedModel.assets = []

        return super.onChange(changedModel);
    }


    /**
     * The fields mapping for the form
     */
    formFields = () => {

        // 'key_clients.*.industries'     => 'required|integer|exists:client_industries',
        // 'key_clients.*.name'            => 'required|string|max:255',
        // 'key_clients.*.year'            => 'required|integer|max:'.now()->year.'|min:1950',
        // 'key_clients.*.image_path'      => 'nullable|string|max:255' OR 'nullable|image',
        // 'key_clients.*.logo_path'       => 'nullable|string|max:255' OR 'nullable|image',
        // 'key_clients.*.description'     => 'nullable|string|max:255',
        let {
            industries = [],
            skills = [],
            disciplines = [],
            brands = [],
            imgAssets = [],
            docAssets = [],
            links = [],
            ...props
        } = this.state.model;

        const allTags = TB.concat(disciplines, skills, industries)

        return [
            {
                style: styles.fieldSection,
                fields: {
                    headline: {
                        type: 'text',
                        label: 'Headline',
                        maxLength: 255,
                        required: true,
                        placeholder: 'Case Study Headline',
                        style: styles.field,
                        columns: 5
                    },
                    year: {
                        label: TB.trans('talent.client_work_form.year_label'),
                        placeholder: TB.trans('talent.client_work_form.year_placeholder'),
                        type: 'select',
                        required: true,
                        options: this.yearOptions(),
                        style: styles.field,
                        columns: 5
                    },
                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    image_path: {
                        label: this.props.isEditing ? TB.trans('talent.client_work_form.add_photo_label') : 'Key Visual',
                        type: 'pixie',
                        circular: false,
                        ratio: '16:9',
                        width: 300,
                        required: false,
                        style: styles.field,
                        columns: 8
                    },
                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    description: {
                        label: TB.trans('talent.client_work_form.summary_paragraph_label'),
                        placeholder: TB.trans('talent.client_work_form.summary_paragraph_placeholder'),
                        type: 'editor',
                        required: true,
                        style: styles.field,
                        maxLength: 10000,
                        minLength:50,
                        columns: 10,
                        rows: 10,
                        validation: {
                            rules: {
                                maxLength: 10000
                            },
                            errors: {
                                maxLength: TB.trans('validation.max.string', {
                                    'attribute': 'summary',
                                    'max': 10000
                                }),
                                minCharLength: TB.trans('validation.min.string', {
                                    'attribute': 'summary',
                                    'min': 50
                                })
                            }
                        }
                    },
                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    divider_1: {
                        component: (
                            <Divider className="mt-1 mb-2"/>
                        ),
                        className: 'py-0',
                    }
                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    brands_display: {
                        required: false,
                        label: 'Brands',
                        className: 'search-brand-input field',
                        component: (
                            <div className={"form-group"} style={styles.field}>
                                <label className="col-form-label flex flex-row items-center gap-7">
                                    <span>
                                        Brands Worked With
                                    </span>
                                    {brands?.length > 0 && (
                                        <span className={TB.mapClass("ml-auto text-xxs italic", {
                                            "opacity-7": brands?.length < MAX_BRANDS_COUNT,
                                            "text-danger font-semibold opacity-1": brands?.length === MAX_BRANDS_COUNT,
                                        })}>
                                            Max ({brands?.length} / {MAX_BRANDS_COUNT})
                                        </span>
                                    )}
                                </label>
                                {brands?.length > 0 && (
                                    <div className="items-stretch flex flex-col mt-5">
                                        <div className="discipline-skills-container">
                                            <FlipMove typeName={null} maintainContainerHeight={true}>
                                                {brands.map((brand, brandIndex) => {
                                                    const brandKey = TB.slugify(`brand-${this.props.itemIndex}-${(brand.id || brand.domain || brand.name)}`)
                                                    return (
                                                        <div key={brandKey}

                                                             className="bg-gray-50 ml-8 mb-8 self-stretch flex flex-row items-center p-1">
                                                            <div id={brandKey}>
                                                                <div className="w-24 self-center">
                                                                    {(brand.logo || brand.icon) ?
                                                                        <img className="w-full max-w-full"
                                                                             src={brand.logo || brand.icon}
                                                                             alt={brand.name}/> : (
                                                                            <PictureOutlined
                                                                                className="w-full max-w-full"
                                                                                style={{fontSize: 56}}/>
                                                                        )}
                                                                </div>
                                                            </div>
                                                            <InfoTooltip type="white"
                                                                         target={brandKey}
                                                                         placement="top">
                                                                <div className="flex flex-col gap-1">
                                                                    <p className="p-0 text-left m-0 text-lg">{brand.name || brand.domain}</p>
                                                                    {brand.name && brand.domain && (
                                                                        <p className="p-0 text-left m-0 text-sm text-info whitespace-nowrap">
                                                                            {brand.domain}
                                                                        </p>
                                                                    )}
                                                                </div>
                                                            </InfoTooltip>
                                                            {this.props.isEditing && !this.props.isDisabled && (
                                                                <div className="self-start ml-2 flex flex-col">
                                                                    <div onClick={e => {

                                                                        let updatedBrands = TB.clone(brands)
                                                                        const newBrandsList = updatedBrands.slice();
                                                                        newBrandsList.splice(brandIndex, 1);
                                                                        this.onChange({
                                                                            ...this.state.model,
                                                                            brands: newBrandsList
                                                                        })
                                                                    }}
                                                                         className="clickable fa fa-times-circle text-danger self-start"/>
                                                                </div>
                                                            )}

                                                        </div>
                                                    );
                                                })}
                                            </FlipMove>
                                        </div>
                                        <Divider className="mt-0 mb-4"/>
                                    </div>
                                )}
                                {this.props.isEditing && (
                                    <div className="mt-1">
                                        <SearchBrandsInput
                                            isDisabled={this.props.isDisabled || brands?.length >= MAX_BRANDS_COUNT}
                                            placeholder={brands?.length < MAX_BRANDS_COUNT ? "Search for brands" : "Max brands limit reached"}
                                            autoClearSearchValue={true}
                                            shouldReset={true}
                                            value={null}
                                            disabledOptions={TB.map(brands, brand => brand.id || brand.brandId || brand.domain)}
                                            onChange={(brand) => this.onChange({
                                                ...this.state.model,
                                                brands: [...(brands || []), brand]
                                            })}/>
                                    </div>
                                )}
                            </div>
                        ),
                        columns: 10
                    }
                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    divider_1: {
                        component: (
                            <Divider className="mt-1 mb-2"/>
                        ),
                        className: 'py-0',
                    }
                }
            },
            {
                style: {display: 'none'},
                fields: {
                    industries: {
                        type: 'hidden',
                        required: false,
                        style: {display: 'none'}
                    },
                    brands: {
                        type: 'hidden',
                        required: false,
                        style: {display: 'none'}
                    },
                    skills: {
                        type: 'hidden',
                        required: false,
                        style: {display: 'none'}
                    },
                    disciplines: {
                        type: 'hidden',
                        required: false,
                        style: {display: 'none'}
                    },
                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    tag_ids: {
                        component: (
                            <div className={"form-group"} style={styles.field}>
                                <label className="col-form-label flex flex-row items-center gap-7">
                                    <span>
                                        Tags
                                    </span>
                                    {allTags?.length > 0 && (
                                        <span className={TB.mapClass("ml-auto text-xxs italic", {
                                            "opacity-7": allTags?.length < MAX_TAGS_COUNT,
                                            "text-danger font-semibold opacity-1": allTags?.length === MAX_TAGS_COUNT,
                                        })}>
                                            Max ({allTags?.length} / {MAX_TAGS_COUNT})
                                        </span>
                                    )}
                                </label>
                                <div className="discipline-skills-container">
                                    <FlipMove typeName={null} maintainContainerHeight={true}>
                                        {TB.map(allTags, (item, index) => {
                                            const colorMap = {
                                                industries: 'default',
                                                skills: 'geekblue',
                                                disciplines: 'purple'
                                            };

                                            const onPreventMouseDown = (event) => {
                                                event.preventDefault();
                                                event.stopPropagation();
                                            };

                                            return (
                                                <Tag
                                                    key={item.value}
                                                    color={colorMap[item.type]}
                                                    onMouseDown={onPreventMouseDown}
                                                    closable={this.props.isEditing}
                                                    onClose={() => {
                                                        let change = {...this.state.model};
                                                        change[item.type] = TB.filter([...(change[item.type] || [])], option => parseInt(option?.id) !== parseInt(item.id))
                                                        this.onChange(change)
                                                    }}
                                                    className="mr-3 my-1.5">
                                                    {item.name}
                                                </Tag>
                                            );
                                        })}
                                    </FlipMove>
                                </div>
                            </div>
                        ),
                        columns: 10,
                    },
                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    tag_search: {
                        className: 'px-0 mb-2',
                        style: styles.field,
                        component: (
                            <div className="px-3.5">
                                <SearchTagsExpertise
                                    isDisabled={this.props.isDisabled}
                                    isEditable={this.props.isEditing}
                                    value={allTags}
                                    maxCount={MAX_TAGS_COUNT}
                                    onChange={params => {
                                        this.onChange({
                                            ...this.state.model,
                                            ...params
                                        });
                                    }}/>
                            </div>
                        ),
                        columns: 10,
                    },

                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    divider_1: {
                        component: (
                            <Divider className="mt-1 mb-2"/>
                        ),
                        className: 'py-0',
                    }
                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    imgAssets: {
                        label: "Other Key Visuals (optional)",
                        type: 'multi-image',
                        display_label: 'Key Visual',
                        accept: '.jpg,.jpeg,.png,.gif,.mp4,.webm,.mov',
                        maxCount: MAX_IMAGE_ASSETS_COUNT,
                        required: false,
                        style: styles.field,
                        columns: 10
                    },
                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    divider_1: {
                        component: (
                            <Divider className="mt-1 mb-2"/>
                        ),
                        className: 'py-0',
                    }
                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    docAssets: {
                        label: "Related Documents (optional)",
                        type: 'multi-doc',
                        display_label: 'Key Visual',
                        accept: '.pdf,.doc,.docx,.txt,.xlsx,.xls,.csv,.ppt,.pptx',
                        mime: 'application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation',
                        maxCount: MAX_DOC_ASSETS_COUNT,
                        required: false,
                        style: styles.field,
                        columns: 10
                    },
                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    divider_1: {
                        component: (
                            <Divider className="mt-1 mb-2"/>
                        ),
                        className: 'py-0',
                    }
                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    links_section: {
                        columns: 10,
                        component: (
                            <div className={"form-group"} style={styles.field}>
                                <label className="col-form-label flex flex-row items-center gap-7">
                                    <span>
                                        Related Links (optional)
                                    </span>
                                    {links?.length > 0 && (
                                        <span className={TB.mapClass("ml-auto text-xxs italic", {
                                            "opacity-7": links?.length < MAX_LINKS_COUNT,
                                            "text-danger font-semibold opacity-1": links?.length === MAX_LINKS_COUNT,
                                        })}>
                                            Max ({links?.length} / {MAX_LINKS_COUNT})
                                        </span>
                                    )}
                                </label>
                                <div className="flex flex-col gap-3">
                                    {TB.map(links, (link, index) => (
                                        <div key={`link-${index}`} className="flex flex-row items-center gap-1.5">
                                            <i className="fa fa-link text-xxs text-gray-400"/>

                                            <a href={link} target="_blank"
                                               className="p-0 btn-link-primary underline text-xs">{link}</a>

                                            <i className="fa fa-times text-danger clickable ml-2" onClick={() => {
                                                return this.onChange({
                                                    ...this.state.model,
                                                    links: TB.filter(links, l => l !== link)
                                                })
                                            }}/>
                                        </div>
                                    ))}
                                    {(!links?.length || links?.length < MAX_LINKS_COUNT) && (
                                        <div className="flex flex-row items-center self-stretch gap-2">
                                            <div className="flex-grow relative">
                                                <FormInputComponent
                                                    key={`new-link-input-${links?.length + 1}`}
                                                    fieldName="newLink"
                                                    className="flex-grow"
                                                    type="url"
                                                    placeholder="https://example.com/newLink"
                                                    label={false}
                                                    value={this.state.newLink || ""}
                                                    required={false}
                                                />
                                            </div>
                                            <Button
                                                disabled={this.props.isDisabled || !isValidURLFormat(this.state.model.newLink || "")}
                                                onClick={() => {
                                                    return this.onChange({
                                                        ...this.state.model,
                                                        newLink: "",
                                                        links: [...links, this.state.model.newLink]
                                                    })
                                                }} type="default" className="text-xs flex flex-row gap-1.5"
                                                size="small">
                                                <i className="fa fa-plus ml-1"/>
                                                <span>Add Link</span>
                                            </Button>
                                        </div>
                                    )}

                                </div>
                            </div>
                        )
                    },
                }
            },
        ]
    };

    renderProfilePreview() {
        return (
            <div className="px-4">
                <ProfileKeyClientRow project={this.getModelFromProps()}/>
            </div>
        )
    }
}

const SearchTagsExpertise = ({onChange, value, isDisabled, isEditable, maxCount = 12, ...props}) => {
    const [searchValue, setSearchValue] = useState('');
    const [isOpen, setIsOpen] = useState(false);

    const tag_ids = TB.map(value || [], 'value');
    const {
        data,
        isInitialLoading: isLoading,
        isFetching,
        error
    } = useAPI(['searchTagsExpertise', {search: searchValue}], {
        enabled: String(searchValue).length > 0,
        initialData: props.initValues || [],
    })

    const searchOptions = useMemo(() => {
        if (isLoading || !data) {
            return;
        }

        const industryOptions = TB.map(data.industries || [], ind => {
                return {
                    value: `industry-${parseInt(ind.id)}`,
                    type: 'industries',
                    label: (
                        <div className="flex flex-row justify-between gap-3 mr-3">
                            <p className="flex-grow">{ind.name}</p>
                            <Tag color='default' closable={false}>Industry</Tag>
                        </div>
                    ),
                    name: ind.name,
                    id: parseInt(ind.id)
                }
            }
        );

        const disciplineOptions = TB.map(data.disciplines || [], dis => ({
            value: `discipline-${parseInt(dis.id)}`,
            type: 'disciplines',
            label: (
                <div className="flex flex-row justify-between gap-3 mr-3">
                    <p className="flex-grow">{dis.name}</p>
                    <Tag color='purple' closable={false}>Wripple Role</Tag>
                </div>
            ),
            name: dis.name,
            id: parseInt(dis.id)
        }));

        let skillOptions = TB.map(data.skills || [], skill => ({
            value: `skill-${parseInt(skill.id)}`,
            type: 'skills',
            label: (
                <div className="flex flex-row justify-between gap-3 mr-3">
                    <p className="flex-grow">{skill.name}</p>
                    <Tag color='geekblue' closable={false}>Skill</Tag>
                </div>
            ),
            name: skill.name,
            id: parseInt(skill.id)
        }));

        return TB.concat(disciplineOptions, skillOptions, industryOptions)
    }, [data, isFetching]);

    return (
        <div>
            <Select
                // mode="multiple"
                // showArrow
                size="small"
                disabled={isDisabled || value?.length >= maxCount}
                placeholder={value?.length < maxCount ? "Search tags for roles, skills, industries" : "Max tags limit reached"}
                open={isOpen}
                showArrow={value?.length < maxCount}
                onFocus={() => setIsOpen(true)}
                onBlur={() => setIsOpen(false)}
                searchValue={searchValue || ''}
                onSearch={value => setSearchValue(value)}
                tagRender={tagRender}
                showSearch={true}
                filterOption={(input, option) => tag_ids.includes(option.value) ? false : (
                        (option?.name ?? '')?.toLowerCase().includes(TB.trimStart(input?.toLowerCase()))) ||
                    TB.trimStart(input?.toLowerCase()).includes((option?.name ?? '')?.toLowerCase()
                    )}
                filterSort={(optionA, optionB) => {
                    const sortValue = value => {
                        if (value.includes('discipline')) {
                            return 0
                        }
                        if (value.includes('skill')) {
                            return 10
                        }
                        if (value.includes('industry')) {
                            return 20
                        }
                    }
                    let sort = sortValue(optionA.value) - sortValue(optionB.value);
                    return sort + (optionA?.name ?? '').toLowerCase().localeCompare((optionB?.name ?? '').toLowerCase())
                }}
                optionFilterProp="children"
                optionLabelProp={searchOptions?.length > 0 ? 'name' : undefined}
                value={null}
                notFoundContent={isFetching ? (
                    <div className="flex flex-col items-center justify-center my-8 h-20 gap-2">
                        <LoadingSpinner size={'lg'}/>

                        <p className="text-sm opacity-6 text-center">Loading results...</p>
                    </div>
                ) : (
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}
                           description={searchValue?.length ? "No tags found." : 'Start typing to search'}/>
                )}
                loading={isFetching}
                autoClearSearchValue={false}
                onSelect={(selectValue, option) => {
                    let options = TB.filter(value || [], ['type', option.type]);
                    let update = {[option.type]: [...options, TB.pick(option, ['id', 'name', 'value', 'type'])]}
                    console.log('onSelectExpertise', {options, update});
                    onChange(update)
                }}
                style={{width: '100%'}}
                options={(searchValue?.length && searchOptions?.length) ? searchOptions : []}

            />
        </div>
    )
}

export {
    SearchTagsExpertise
}
const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
};